import PropTypes from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import Storage from "../../../utils/storage";
import {
  submitRequestForm,
  uploadKey,
} from "../../../redux/Actions/NipOnboardingActions";
import Approved from "./Nip-PublicKeys/Approved";
import Rejected from "./Nip-PublicKeys/Rejected";
import UploadKeys from "./Nip-PublicKeys/UploadKeys";

export const assignUrlFunc = (state, uploadKey) => {
  const formData = new FormData();
  formData.append("key", state.public_key_url);
  uploadKey(formData);
  return "";
};

export const submitValuesFunc = (
  application,
  data,
  submitApplication,
  keyUploaded
) => {
  const type = "upload";
  const payload = {
    type: application && application.application_type,
    application_id: application && application.application_id,
    test_ip: data && data.ip,
    prod_ip: data && data.production_ip,
    public_key: keyUploaded,
  };
  submitApplication(payload, type);

  return "";
};

const PublicKeys = (props) => {
  const {
    application,
    isSubmitting,
    submitApplication,
    goToPrev,
    uploadKey,
    isUploadingKey,
    uploadSuccess,
    keyUploaded,
  } = props;

  let userStatus = Storage.get("user-access-data");
  const user = JSON.parse(userStatus);
  let userType = user && user.type;

  const [showAlert, setShowAlert] = useState(true);
  const dataObject = Storage.get("data");
  const data = dataObject && JSON.parse(dataObject);
  const trail = application && application.nip_trail;
  const appId = application && application.application_id;
  const type = application && application.application_type;
  const permitStatus =
    application &&
    application.ip_permit_info &&
    application.ip_permit_info.ip_permit_status;
  const permitInfo = application && application.ip_permit_info;
  const permitInfoPublicKey = permitInfo && permitInfo.public_key;
  const bankCode = application && application.bank_code;
  const wsdlUrl =
    application &&
    application.inward_test_data &&
    application.inward_test_data.wsdl_url;
  const acctNumber =
    application &&
    application.inward_test_data &&
    application.inward_test_data.beneficiary_account_number;

  const [state, setState] = useState({
    loaded: false,
    public_key_url: "",
    error: "",
  });

  const showWidget = (event) => {
    setState({ public_key_url: event.target.files[0], loaded: true });
    assignUrl();
  };

  const assignUrl = () => {
    assignUrlFunc(state, uploadKey);
  };

  const removeFile = () => {
    setState({
      ...state,
      public_key_url: "",
      error: "Public key is required",
      loaded: false,
    });
  };

  const submitValues = () => {
    submitValuesFunc(application, data, submitApplication, keyUploaded);
  };

  return (
    <div className="nip-public-keys">
      {showAlert &&
        userType === "company_network_manager" &&
        !trail.ip_form_submission &&
        !trail.ip_permit_approval &&
        !permitStatus && (
          <div>
            <div className="nip-integration-header">Share Public Keys</div>
            <br />
            <UploadKeys
              submitValues={submitValues}
              state={state}
              showWidget={showWidget}
              removeFile={removeFile}
              isSubmitting={isSubmitting}
              uploadSuccess={uploadSuccess}
              isUploadingKey={isUploadingKey}
            />
          </div>
        )}
      {showAlert && trail.ip_form_submission && !trail.ip_permit_approval ? (
        <div>
          <div className="nip-integration-header">Share Public Keys</div>
          <br />
          <div className="nip-public-keys-alert1">
            <div className="text1">
              Your application is pending, please check back later to continue
              integration. Thank you.
            </div>
            <div
              className="close1"
              data-testid={"close1"}
              onClick={() => setShowAlert(false)}
            >
              X
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
      {permitStatus === "rejected" &&
      !trail.ip_form_submission &&
      !trail.ip_permit_approval ? (
        <Rejected
          showAlert={showAlert}
          setShowAlert={() => setShowAlert(false)}
          application={application}
          goToNext={goToPrev}
          isSubmitting={isSubmitting}
          submitApplication={submitApplication}
          userType={userType}
        />
      ) : (
        <></>
      )}
      {permitStatus === "approved" &&
      trail.ip_form_submission &&
      trail.ip_permit_approval ? (
        <div>
          <div className="nip-integration-header">Share Public Keys</div>
          <br />
          <Approved
            showAlert={showAlert}
            setShowAlert={() => setShowAlert(false)}
            publicKey={permitInfoPublicKey}
            type={type}
            userType={userType}
            appId={appId}
            bankCode={bankCode}
            wsdlUrl={wsdlUrl}
            acctNumber={acctNumber}
          />
        </div>
      ) : (
        <div></div>
      )}
    </div>
  );
};

PublicKeys.propTypes = {
  application: PropTypes.shape({
    account_number: PropTypes.any,
    application_id: PropTypes.any,
    application_type: PropTypes.any,
    bank_code: PropTypes.any,
    inward_test_data: PropTypes.shape({
      account_number: PropTypes.any,
      beneficiary_account_number: PropTypes.any,
      wsdl_url: PropTypes.any
    }),
    ip_permit_info: PropTypes.shape({
      ip_permit_status: PropTypes.any
    }),
    nip_trail: PropTypes.any,
    wsdl_url: PropTypes.any
  }),
  goToPrev: PropTypes.any,
  isSubmitting: PropTypes.any,
  isUploadingKey: PropTypes.any,
  keyUploaded: PropTypes.any,
  submitApplication: PropTypes.any,
  uploadKey: PropTypes.any,
  uploadSuccess: PropTypes.any
}

const mapStateToProps = (state) => {
  return {
    isSubmitting: state.nipOnboarding.isSubmittingRequestForm,
    isUploadingKey: state.nipOnboarding.isUploadingKey,
    keyUploaded: state.nipOnboarding.key,
    uploadSuccess: state.nipOnboarding.uploadSuccess,
  };
};

const mapDispatchToProps = (dispatch) => ({
  submitApplication: (payload, type) =>
    dispatch(submitRequestForm(payload, type)),
  uploadKey: (payload) => dispatch(uploadKey(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicKeys);
